<div class="payment-failed-container">
    <div class="icon">&#10006;</div> <!-- símbolo de cruz (✖) -->
    <h1>Pago no realizado</h1>
    <p>Tu pago no se ha podido procesar correctamente.</p>
    <p>Por favor, revisa los datos o intenta de nuevo más tarde.</p>
    <button (click)="retryPayment()">Reintentar pago</button>
  </div>
  
